"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientContext = exports.ClientContext = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "ClientContext", { enumerable: true, get: function () { return shared_1.ClientContext; } });
Object.defineProperty(exports, "useClientContext", { enumerable: true, get: function () { return shared_1.useClientContext; } });
